/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Save_ButtonInputs */

const en_candidate_profile_save_button = /** @type {(inputs: Candidate_Profile_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Profile`)
};

const de_candidate_profile_save_button = /** @type {(inputs: Candidate_Profile_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil speichern`)
};

/**
* | output |
* | --- |
* | "Save Profile" |
*
* @param {Candidate_Profile_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_save_button = /** @type {((inputs?: Candidate_Profile_Save_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Save_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_save_button(inputs)
	return en_candidate_profile_save_button(inputs)
});